import { URLs } from "../url";
import { ProjectTypeResponse } from "../../model/projectType";
import { getHeader } from "../headers";
import { handleUnauthorized } from "../fetchRequest";

const getProjectType = async (
  clientId: string,
  enable: boolean,
  page: number,
  limit: number,
) => {
  let newURL =
    process.env.REACT_APP_HOST_API +
    URLs.projectType +
    `?clientId=${clientId}` +
    `&enable=${enable}&page=${page}&limit=${limit}`;
  const requestOptions = {
    method: "GET",
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return (await response.json()) as ProjectTypeResponse;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const postProjectType = async (body: any) => {
  const newURL = process.env.REACT_APP_HOST_API + URLs.projectType;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify({ data: body }),
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return (await response.json()) as ProjectTypeResponse;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const patchProjectType = async (body: any, id: string) => {
  let newURL = process.env.REACT_APP_HOST_API + URLs.projectType + `/${id}`;
  const requestOptions = {
    method: "PATCH",
    body: JSON.stringify({ data: body }),
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return (await response.json()) as ProjectTypeResponse;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { getProjectType, postProjectType, patchProjectType };
